import { Brand } from './Brand'
import { Icon } from './Icon'

type FooterProps = {
  audience?: 'firms' | 'professionals'
}

export function Footer({ audience = 'firms' }: FooterProps) {
  const professionalPage = audience === 'professionals'

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Brand href="/#top" />
            <p>
              Qualified South African finance professionals, integrated into
              international accounting and audit teams and supported locally by
              Ark Solutions.
            </p>
          </div>
          <div className="footer-col">
            <h3>Explore</h3>
            <a href="/#why-ark">Why Ark Solutions</a>
            <a href="/#how-it-works">How it works</a>
            <a href="/#why-south-africa">Why South Africa</a>
            <a href={professionalPage ? '#professional-faqs' : '#faqs'}>FAQs</a>
          </div>
          <div className="footer-col">
            <h3>For firms</h3>
            <a href="/#conversation">Explore your talent requirements</a>
            <a href="mailto:partnerships@arksolutionsza.com">partnerships@arksolutionsza.com</a>
          </div>
          <div className="footer-col">
            <h3>For professionals</h3>
            <a href="/for-professionals">Explore opportunities</a>
            <a href="/for-professionals#professional-enquiry">Share your interest</a>
          </div>
          <div className="footer-col footer-contact">
            <h3>{professionalPage ? 'Professional enquiries' : 'Partnership enquiries'}</h3>
            <a href={`mailto:${professionalPage ? 'professionals' : 'partnerships'}@arksolutionsza.com`}>
              <Icon name="mail" />
              {professionalPage ? 'professionals' : 'partnerships'}@arksolutionsza.com
            </a>
            <span>
              <Icon name="pin" />
              Cape Town, South Africa
            </span>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Ark Solutions. All rights reserved.</span>
          <div className="footer-legal">
            <a href="/privacy">Privacy</a>
            <span aria-disabled="true" title="Terms will be added before launch">Terms</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
